import { builtInViews } from "@hq/core";
import { cn } from "@z/ui";
import { CalendarRange } from "lucide-react";
import { QuickAdd } from "../QuickAdd";
import { TaskList } from "../TaskList";
import { ViewHeader } from "../ViewHeader";
import { type ViewProps, viewClassName } from "./shared";
import { useViewState } from "./useViewState";

/** The next 14 days of deadlines, one heading per day ("Today · Wed 16 Sep", "Tomorrow · …"). */
export function UpcomingView({ onOpenTask, now, className }: ViewProps) {
  const s = useViewState(builtInViews.upcoming);
  return (
    <div data-slot="upcoming-view" className={cn(viewClassName, className)}>
      <ViewHeader
        mode={s.mode}
        onModeChange={s.setMode}
        title={
          <span className="inline-flex items-center gap-2">
            <CalendarRange className="size-4 text-fg-muted" />
            Upcoming
          </span>
        }
        sort={s.sort}
        onSortChange={s.setSort}
        tags={s.tags}
        onTagsChange={s.setTags}
        availableTags={s.hasTasks ? s.allTags : []}
        displayControls={s.hasTasks && s.mode === "list"}
        groupBy={s.groupBy}
        onGroupByChange={s.setGroupBy}
        showCompleted={s.showCompleted}
        onShowCompletedChange={s.setShowCompleted}
      />
      <TaskList
        view={s.view}
        mode={s.mode}
        onTagClick={s.toggleTag}
        quickAdd={
          <QuickAdd
            {...(now ? { now } : {})}
            placeholder="Add a task with a date… e.g. “Renew passport by Friday”"
          />
        }
        emptyTitle="Nothing planned ahead"
        emptyDescription="Future work days and deadlines appear here, grouped by the next date."
        {...(onOpenTask ? { onOpenTask } : {})}
        {...(now ? { now } : {})}
      />
    </div>
  );
}
